import { SAVE_WEBCHAT_DATA } from "actions/const";
import {
  STATE_COMMUNICATION_CONFIG_DEFAULT,
  STATE_COMMUNICATION_CONFIG_DATA,
} from "./default";
import { createReducer } from "../base";

export default createReducer(STATE_COMMUNICATION_CONFIG_DEFAULT, {
  [SAVE_WEBCHAT_DATA]: (state, { value }) =>
    state.set(STATE_COMMUNICATION_CONFIG_DATA, value),
});

export * from "./selectors";
export * from "./default";
